import { render, staticRenderFns } from "./hot-panel.vue?vue&type=template&id=1cd20cc7"
import script from "./hot-panel.vue?vue&type=script&lang=js"
export * from "./hot-panel.vue?vue&type=script&lang=js"
import style0 from "./hot-panel.vue?vue&type=style&index=0&id=1cd20cc7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports